// extracted by mini-css-extract-plugin
export default {"input_link":"LinkModal_input_link__sb7X5","button_div":"LinkModal_button_div__YPeYU"};